export enum PageTypes {
  GENERAL = 'general',
  ROOM = 'room',
}
